import type { UseFetchOptions } from "#app"
import { useUserStore } from "@/stores/user"

interface ApiResponse<T> {
  data: T
  message: string
  success: boolean
}

export async function useCustomFetch<T>(
  url: string,
  options: UseFetchOptions<ApiResponse<T>> = {} as UseFetchOptions<
    ApiResponse<T>
  >,
) {
  const runtimeConfig = useRuntimeConfig()
  const userAuth = useCookie("access_token")
  const normalizedMethod = (options.method || "GET").toString().toUpperCase()

  const defaults: UseFetchOptions<ApiResponse<T>> = {
    // baseURL: config.baseURL,
    ignoreResponseError: true,
    key: undefined, // disable cache/dedupe for mutations
    method: normalizedMethod,

    headers: {
      Authorization: userAuth.value ? `Bearer ${userAuth.value}` : ``,
      "Accept-Language": "tr",
      "Content-Type": "application/json",
      "X-User-Type":
        runtimeConfig.public.source === "customer" ? "360sosyal" : "gigcep",
    },
    onRequest({ request, options }) {},
    onResponse(_ctx) {
      const userStore = useUserStore()
      // console.log('_ctx.response?._data', _ctx.response)
      if (
        [
          "Unauthenticated.",
          "UNAUTHORIZED",
          "Yetkisiz işlem.",
          "Bu işlemi yapmak için yetkiniz yoktur.",
        ].includes(_ctx.response?._data?.message)
      ) {
        const router = useRoute()
        if (["/verify", "/two-factor"].includes(router.path)) {
          return
        }
        userStore.logout()
      }
    },

    onResponseError(_ctx) {
      // console.log('onResponseError', _ctx)
      // throw new myBusinessError()
    },
  }

  // manual shallow merge; headers merged explicitly so user options override defaults
  const mergedHeaders = {
    ...(defaults.headers as any),
    ...(options.headers as any),
  }

  const params: UseFetchOptions<ApiResponse<T>> = {
    ...defaults,
    ...options,
    method: normalizedMethod,
    key: normalizedMethod === "GET" ? options.key ?? url : undefined,
    headers: mergedHeaders,
    // force client-only for mutations to avoid SSR invisibility (optional, uncomment if needed)
    // server: normalizedMethod === 'GET' ? options.server : false,
  }

  return useFetch<ApiResponse<T>>(url, params)
}
